import logo from './logo.svg';
import './App.css';
import './Fonts/Poppins-Light.ttf';
import ExpenseTracker from './Components/ExpenseTracker';
import './Components/ExpenseTracker.css'

function App() {
  return (
    <div className="App">
      <ExpenseTracker />

    </div>
  );
}

export default App;
